"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TimeRangePicker = void 0;
require("flatpickr/dist/flatpickr.css");
const React = __importStar(require("react"));
const TimePicker_1 = require("./TimePicker");
const TimeRangePicker = (props) => {
    return (React.createElement("div", { className: "time-range-picker" },
        React.createElement(TimePicker_1.TimePicker, { selectedTime: props.selectedStartTime, onTimeChange: props.onStartTimeChange, options: Object.assign({ altInputClass: 'time-enabled time-range-start-picker form-control' }, props.options), disabled: props.disabled }),
        React.createElement(TimePicker_1.TimePicker, { selectedTime: props.selectedEndTime, onTimeChange: props.onEndTimeChange, options: props.options, disabled: props.disabled })));
};
exports.TimeRangePicker = TimeRangePicker;
//# sourceMappingURL=TimeRangePicker.js.map